<template>
  <v-data-table hide-default-footer no-data-text style="border-radius: 0"
    v-bind:items="items" v-bind:headers="headers" show-expand single-expand>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" style="padding: 0">
        <template v-if="item.item_tree">
          <v-categories-table v-bind:items="item.subs" v-bind:headers="headers"/>
        </template>
        <template v-else>
          No more categories
        </template>
      </td>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: 'v-categories-table',
  props: {
    items: Array,
    headers: Array
  }
}
</script>